export default "__VITE_ASSET__Bhj71WMv__"